"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SocialLinks = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("../../../hooks");
var _brandContextProvider = require("../../../contextProviders/brandContextProvider");
var _contextProps = require("../../../propTypes/contextProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/destructuring-assignment */

const SocialLinks = _ref => {
  let {
    socialLinks
  } = _ref;
  const brandContext = (0, _react.useContext)(_brandContextProvider.BrandContext);
  let brandSocialLinks = [];
  if (brandContext && brandContext.activeBrandContext) {
    brandSocialLinks = brandContext.activeBrandContext.theme.layout.footer.socialLinks;
  }
  const socialLinksSet = socialLinks || brandSocialLinks;
  if (!socialLinksSet || socialLinksSet.length === 0) {
    return null;
  }
  const SocialLink = _ref2 => {
    let {
      socialLink
    } = _ref2;
    const socialLinkElement = (0, _react.useRef)(null);
    (0, _hooks.useTracking)({
      elementRef: socialLinkElement,
      trackingProps: {
        label: socialLink.label,
        elementType: 'a',
        url: socialLink.href || socialLink.url
      }
    });
    return /*#__PURE__*/_react.default.createElement("a", {
      ref: socialLinkElement,
      title: socialLink.label,
      target: "_blank",
      rel: "noreferrer",
      href: socialLink.href || socialLink.url
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, socialLink.label), socialLink.svg);
  };
  SocialLink.propTypes = _contextProps.SocialLinkProps;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "socialLinks"
  }, socialLinksSet.map(socialLink => /*#__PURE__*/_react.default.createElement("li", {
    key: socialLink.icon
  }, /*#__PURE__*/_react.default.createElement(SocialLink, {
    socialLink: socialLink
  }))));
};
exports.SocialLinks = SocialLinks;
SocialLinks.propTypes = {
  socialLinks: _propTypes.default.arrayOf(_propTypes.default.shape(_contextProps.SocialLinkProps))
};
var _default = exports.default = SocialLinks;